import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../api";
import hand from "../../assets/mano.png";
import esquema from "../../assets/scenario5-esquema2.png";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { useGameTexts } from "../../hooks/useGameTexts";
import { useLang } from "../../translations/i18n";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario5Result({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const { texts, ready } = useGameTexts(group?.game);

	const scenarioNum = getScenarioByScreen(location.pathname);

	// Precargar imágenes de scenario5.2-intro e intro2 para que no carguen tarde al llegar
	useEffect(() => {
		if (!ready) return;
		const introPath = texts["scenario5.2.intro.image"];
		const intro2Path = texts["scenario5.2.intro2.image"];
		if (introPath) {
			const u = buildImageUrl(introPath);
			if (u) { const img = new Image(); img.src = u; }
		}
		if (intro2Path) {
			const u = buildImageUrl(intro2Path);
			if (u) { const img = new Image(); img.src = u; }
		}
	}, [ready, texts["scenario5.2.intro.image"], texts["scenario5.2.intro2.image"]]);

	return (
		<div className="h-100 bg-prueba">
			<div className="container">
				<div className="row h-100 d-flex align-items-center pt-5">
					<div className="col-9 d-flex justify-content-start align-items-center">
						<img width={"100%"} src={esquema}></img>
					</div>
					<div className="col-3 d-flex align-items-start">
						<img src={hand} />
						<div className="txt-white ms-2">
							Como curiosidad, la respuesta b) correspondía a los
							criterios propuestos para los 6 meses.
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "13vh",
					zIndex: 1000,
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton navigateTo={ROUTES.SCENARIO5_END} />
				</div>
			</div>
			<ScenarioBar activeScenario={scenarioNum}></ScenarioBar>
		</div>
	);
}

export default injectIntl(Scenario5Result);
